"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _sizes = require("@decisiv/design-tokens/lib/iconography/sizes");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var SvgEyeSlash32 = function SvgEyeSlash32(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutProperties(_ref, ["size", "color"]);

  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    width: _sizes.alias[size],
    height: _sizes.alias[size],
    color: color,
    focusable: "false"
  }, props), _react.default.createElement("path", {
    d: "M31.707 1.707A1 1 0 0030.293.293l-6.699 6.699C21.306 5.753 18.734 5 16 5 8.9 5 2.891 10.08.109 15.546a1 1 0 101.782.908C4.436 11.454 9.857 7 16 7c2.156 0 4.223.549 6.109 1.477l-4.816 4.815a3 3 0 00-4.001 4.001l-1.464 1.464a5 5 0 015.97-7.424 1 1 0 10.72-1.866 7 7 0 00-8.125 10.725l-2.298 2.299a18.292 18.292 0 01-3.359-2.875 1 1 0 10-1.472 1.353 20.412 20.412 0 003.391 2.962L.293 30.293a1 1 0 101.414 1.414l6.7-6.7C10.692 26.245 13.265 27 16 27c5.067 0 9.577-2.595 12.736-6.03a1 1 0 10-1.472-1.354C24.379 22.752 20.37 25 16 25c-2.155 0-4.222-.546-6.11-1.476l1.918-1.918a7 7 0 0010.924-7.53 1 1 0 00-1.923.55 5 5 0 01-7.566 5.546l1.464-1.464a3 3 0 004.001-4.001l5.197-5.197a18.58 18.58 0 016.204 6.944 1 1 0 001.782-.908c-1.428-2.806-3.706-5.51-6.546-7.477l6.362-6.362z",
    fill: "currentColor"
  }));
};

SvgEyeSlash32.propTypes = {
  size: _propTypes.default.oneOf(Object.keys(_sizes.alias)),
  color: _propTypes.default.string
};
var _default = SvgEyeSlash32;
exports.default = _default;